import React, { useState } from "react";
import { FaBars, FaTimes, FaSearch } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";

const Header: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const navItems = [
    { label: t("Home"), path: "/" },
    
    { label: t("Destinations"), path: "/destination" },
   
    { label: t("Visa Services"), path: "/visa-services" },
    { label: "Flight Booking", path: "/flight-booking" },
    // { label: "Hotel Booking", path: "/hotel-booking" },
    // { label: "Blog", path: "/blog" },
    { label: t("About Us"), path: "/about-us" },
    { label: t("Support"), path: "/help-and-support" },
  ];

 const handleNavigate = (path: string) => {
    if (path === "/flight-booking") {
      window.open("https://www.buybestfares.com", "_blank");
      setMobileMenuOpen(false);
      return;
    }
    navigate(path);
    setMobileMenuOpen(false);
  };

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-brand-dark/90 backdrop-blur-md border-b border-white/10 py-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center">
        
        {/* Logo */}
      <div
  onClick={() => navigate("/")}
  className="cursor-pointer flex items-center gap-2"
>
  <img 
    src="/logo111.png" 
    alt="GET2VACATIONS Logo" 
    className="h-8 md:h-10 w-auto rounded-lg"
    onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
      e.currentTarget.style.display = 'none';
    }}
  />
  
  <h1 className="font-heading text-xl md:text-2xl font-bold tracking-wider text-white">
    GET2<span className="text-brand-pink">VACATIONS</span>
  </h1>
</div>
        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
          {navItems.map((item) => (
            <button
              key={item.path}
              onClick={() => handleNavigate(item.path)}
              className={`relative text-sm font-medium transition-colors ${
                isActive(item.path)
                  ? "text-white"
                  : "text-gray-300 hover:text-white"
              }`}
            >
              {item.label}

              {/* Animated underline */}
              <span
                className={`absolute left-0 -bottom-1 h-[2px] bg-brand-pink transition-all duration-300 ${
                  isActive(item.path) ? "w-full" : "w-0 group-hover:w-full"
                }`}
              ></span>
            </button>
          ))}
        </nav>

        {/* Desktop Actions */}
        <div className="hidden lg:flex items-center gap-4">
          <LanguageSwitcher />

          <button className="text-white hover:text-brand-pink transition-colors">
            <FaSearch />
          </button>

    
        </div>

        {/* Mobile Toggle */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="lg:hidden text-white text-2xl p-2"
        >
          {mobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden absolute top-full left-0 w-full bg-brand-dark border-b border-white/10 py-6 px-4 space-y-4 shadow-2xl">
          <nav className="flex flex-col gap-4">
            <div className="w-fit">
              <LanguageSwitcher />
            </div>
            {navItems.map((item) => (
              <button
                key={item.path}
                onClick={() => handleNavigate(item.path)}
                className={`text-left font-medium ${
                  isActive(item.path)
                    ? "text-white"
                    : "text-gray-300"
                }`}
              >
                {item.label}
              </button>
            ))}
          </nav>

          <div className="pt-4 border-t border-white/10">
            <button
              onClick={() => handleNavigate("/login")}
              className="w-full py-3 bg-brand-pink text-white rounded-xl font-medium"
            >
              {t("Sign In")}
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
